/**
 * Mutates provided Node to convert `br` tags used to separate paragraphs/divs into `p` tags.
 * */
export function replaceHardBreaksWithParagraphs(dom: Node) {
  if (dom instanceof Element) {
    dom.querySelectorAll('br').forEach((brTag) => {
      const previousSiblingName = brTag.previousElementSibling?.nodeName;
      const nextSiblingName = brTag.nextElementSibling?.nodeName;
      if (
        previousSiblingName === 'P' ||
        previousSiblingName === 'DIV' ||
        nextSiblingName === 'P' ||
        nextSiblingName === 'DIV'
      ) {
        brTag.replaceWith(document.createElement('p'));
      }
    });
  }
}
